/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
// import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */

export async function loadSalesApproval( searchValue) {

  if (searchValue) {
    return await api
      .post(`/get_all_pending_qc`,searchValue)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_pending_qc`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadSalesApproval,
  loadEmployeeList,
}

export default remotes
